import { ChartDiv } from './ChartDiv.js';
import { ChartSVG } from './ChartSVG.js';

const ChartElements = {
  Div: ChartDiv,
  Svg: ChartSVG
};

export { ChartElements };
